import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UpgradeNavigationServiceHandler } from '../../Common/Routing/upgrade-navigation-handler.service';
import { BreadCrumb, BreadCrumbsComponent } from '../../UI-Lib/Bread-Crumb/breadCrumbs.component';
import { Invoice, InvoiceRouteNames, OverrideStatus } from './invoice.model';
import { InvoiceService } from './invoice.service';
import { LaunchTaskModalService } from '../../Task/launchTaskModal.service';
import { Constants, ContractServiceType, EntityType, TaskType } from '../../constants.new';
import { InvoiceRecipientLookupComponent } from '../../Common/Contracts-Invoices/invoice-recipient-lookup.component';
import { ToastrService } from 'ngx-toastr';
import {
    AttachmentModalData,
    AttachmentModalEntityData,
    AttachmentBundlerContext,
} from '../../Attachment/attachment.modal.model';
import { CommentModalData } from '../../Comments/comments.service';
import { NavigationService } from '../../Layout/navigation.service';
import { ActionViewPersistenceService } from '../../Task/ActionView/Action.View.Persistence.Service.upgrade';
import { ActionViewStateService } from '../../Task/ActionView/actionViewState.service';
import { RestrictService, Roles } from '../../Common/Permissions/restrict.service';
import { FeatureFlagsService } from '../../Common/FeatureFlags/feature-flags-service';
import { ContractTerm, SiteContractTerm, TermItem } from 'src/app/Common/Contracts-Invoices/contract-invoices.model';
import { ContractsInvoicesService } from '../../Common/Contracts-Invoices/contract-invoices.service';
import { CommonModule } from '@angular/common';
import { AceLoaderComponent } from '../../UI-Lib/ACE/Loader/loader.component';
import { FormsModule } from '@angular/forms';
import { AnchorRouteDirective } from '../../UI-Lib/Directives';
import { EntityAttachmentsComponent } from '../../Attachment/Entity/entity-attachments.component';
import { EntityCommentsButtonComponent } from '../../Comments/Entity-Comments-Button/entityCommentsButton.component';
import { WeissmanDatetimeComponent } from '../../UI-Lib/Weiss-Datepicker/weissman-datetime.component';
import { SwitchComponent } from '../../UI-Lib/Switch/switch.component';
import { TermRatesAndFeesComponent } from '../../Common/Contracts-Invoices/term-rates-and-fees.component';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { InvoiceDetailsComponent } from './Invoice-Details/invoiceDetails.component';
import { FeeAllocationComponent } from './Fee-Allocation/fee-allocation.component';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { UIRouter } from '@uirouter/angular';
import {
    MessageModalButtons,
    MessageModalDisplayMode,
    MessageModalService,
} from '../../UI-Lib/Message-Box/messageModal.service';
import { InvoiceDetailsOldComponent } from './Invoice-Old/Details/invoice-details.component';
import { HelpModule } from '../../UI-Lib/Help-Tooltip/help.module';
import { Attachment } from '../../Attachment/attachment.model';

import * as _ from 'lodash';
import AttachmentTypes = Core.AttachmentTypes;

@Component({
    selector: 'invoice',
    templateUrl: './invoice.component.html',
    styleUrl: './invoice.component.scss',
    imports: [
        CommonModule,
        FormsModule,
        BreadCrumbsComponent,
        AceLoaderComponent,
        AnchorRouteDirective,
        EntityAttachmentsComponent,
        EntityCommentsButtonComponent,
        WeissmanDatetimeComponent,
        InvoiceRecipientLookupComponent,
        SwitchComponent,
        TermRatesAndFeesComponent,
        PopoverDirective,
        InvoiceDetailsComponent,
        FeeAllocationComponent,
        TooltipDirective,
        InvoiceDetailsOldComponent,
        HelpModule,
    ],
})
export class ProcessInvoiceComponent implements OnInit {
    constructor(
        public invoiceService: InvoiceService,
        private readonly navigationServiceHandler: UpgradeNavigationServiceHandler,
        private readonly navigationService: NavigationService,
        private readonly actionViewPersistenceService: ActionViewPersistenceService,
        private readonly actionViewStateService: ActionViewStateService,
        private readonly launchTaskModalService: LaunchTaskModalService,
        private readonly constants: Constants,
        private readonly messageBox: MessageModalService,
        private readonly _toastr: ToastrService,
        private readonly _featureFlagsService: FeatureFlagsService,
        private readonly _contractsInvoicesService: ContractsInvoicesService,
        private readonly _router: UIRouter,
        private readonly _cdRef: ChangeDetectorRef,
        restrictService: RestrictService,
    ) {
        this.canTransferToRIBS = restrictService.isInRole(Roles.FINANCIALANALYST);
        this.enableInvoiceUBR = _featureFlagsService.featureFlags.enableInvoiceUBR;
        this.isRyanLegalServiceEnabled = true;
    }

    @ViewChild('invoiceRecipientLookup') invoiceRecipientLookup: InvoiceRecipientLookupComponent;

    canTransferToRIBS: boolean;
    // Primary invoice object
    currentInvoice: Invoice;
    cachedInvoice: Invoice;

    breadcrumbs: BreadCrumb[];

    //If there's a queue, this will be populated (aka from Action View)
    taskList: number[];
    taskIndex: number = 0;

    ContractServiceType = ContractServiceType;

    loading: boolean = true;
    editMode: boolean;
    taskOnlyEditMode: boolean;
    isInvoiceCompleted: boolean;
    callInProgress: boolean;
    enableInvoiceUBR: boolean;
    isRyanLegalServiceEnabled: boolean;
    showCompleteButton: boolean;
    canChangeContractType: boolean;
    isAppealSavingsInvoice: boolean;
    enableImprovedInvoiceSavings: boolean;

    attachmentData: AttachmentModalData;
    commentData: CommentModalData;

    completeText: string;
    closeText: string;
    currentState: any;

    invoiceDetailsCompletedDate: Date;
    appealContractTypes: Compliance.NameValuePair<ContractServiceType>[] = [];
    companyAppealContractTerms: ContractTerm[] = [];
    currentContractTermDetailId: number;

    private _siteIdParam: string;
    private _siteAppealContractTerms: SiteContractTerm[];
    private _currentContractTerm: ContractTerm;
    private _currentAttachments: Attachment[] = [];
    private _isContractTermOverridden: boolean;
    private _navigationWarningText: string =
        'If you continue you will lose your unsaved changes. Do you wish to continue?';

    get contractTerm(): ContractTerm {
        return this._currentContractTerm;
    }

    get isContractTermOverridden(): boolean {
        return this._isContractTermOverridden;
    }

    async ngOnInit(): Promise<void> {
        this.enableImprovedInvoiceSavings = this._featureFlagsService.featureFlags.enableImprovedInvoiceSavings;

        await this.setupPage();

        this._siteIdParam = this._router.globals.params['siteID'];

        this._processNewInvoice();
    }

    async setupPage(): Promise<void> {
        const state = this.navigationServiceHandler.getCurrentState();
        let invoiceId: string;

        this.currentState = state;

        if (state.name === InvoiceRouteNames.Company || state.name === InvoiceRouteNames.Site) {
            invoiceId = this.navigationServiceHandler.getQuerystringParam('invoiceID');
            await this.getInvoiceById(invoiceId);
        } else if (state.name === InvoiceRouteNames.Processing) {
            const draftId = this.navigationServiceHandler.getQuerystringParam('draftId');
            const taskString: string = sessionStorage[`InvoiceDrafts${draftId}`];
            this.taskList = JSON.parse(taskString);
            this.editMode = true;
            this.navigationService.enableNavWarning(this._navigationWarningText);
            await this.getInvoiceForTask(this.taskList[this.taskIndex]);
        }
    }

    async getInvoiceById(invoiceId: string): Promise<Invoice> {
        this.loading = true;
        const companyIDErrMsg = 'Company ID does not match Invoice';
        const siteIDErrMsg = 'Site ID does not match Invoice';
        const notFoundErrMsg = 'Invoice not found';

        try {
            const resultInvoice = await this.invoiceService.getInvoice(invoiceId);
            const companyIDParam = this.navigationServiceHandler.getQuerystringParam('companyID');
            const siteIDParam = this.navigationServiceHandler.getQuerystringParam('siteID');
            if (companyIDParam && +companyIDParam != resultInvoice.companyId) {
                throw new Error(companyIDErrMsg);
            }
            if (siteIDParam && +siteIDParam != resultInvoice.siteId) {
                throw new Error(siteIDErrMsg);
            }

            this.currentInvoice = resultInvoice;
            this._processNewInvoice();

            this.stashCurrentInvoice(resultInvoice);

            this.setButtonText();
            this.setAttachmentAndComments();
            this.isInvoiceCompleted = !this.currentInvoice.readyTaskId;

            await this._initFromCurrentInvoice();

            return this.currentInvoice;
        } catch (err) {
            if ([companyIDErrMsg, siteIDErrMsg, notFoundErrMsg].indexOf(err.message) >= 0) {
                this._toastr.error(err.message);
            }
            throw err;
        } finally {
            this.loading = false;
        }
    }

    async getInvoiceForTask(taskId: number): Promise<void> {
        this.loading = true;

        try {
            const resultInvoice = await this.invoiceService.getInvoiceForTask(taskId);
            this.currentInvoice = resultInvoice;
            this._processNewInvoice();

            this.stashCurrentInvoice(resultInvoice);

            this.setButtonText();
            this.setAttachmentAndComments();

            await this._initFromCurrentInvoice();
        } finally {
            this.loading = false;
        }
    }

    setAttachmentAndComments(): void {
        this.attachmentData = new AttachmentModalData();
        this.commentData = new CommentModalData();

        this.commentData.entityID = this.currentInvoice.invoiceId;
        this.commentData.entityTypeID = EntityType.Invoice;
        this.commentData.description = 'Invoice';
        this.commentData.year = this.currentInvoice.annualYear.toString();
        this.commentData.canEdit = true;
        //TODO: Permission?

        this.attachmentData.entityData = new AttachmentModalEntityData();
        this.attachmentData.entityData.id = this.currentInvoice.invoiceId;
        this.attachmentData.entityData.typeId = EntityType.Invoice;
        this.attachmentData.entityData.name = 'invoice';
        // WK-9232 Invoice attachments can have no year
        // this.attachmentData.disableYears = true;
        this.attachmentData.year = this.currentInvoice.annualYear;
        this.attachmentData.singleYear = true;
        //this.attachmentData.entityName = this.currentInvoice.invoiceNumber ? this.currentInvoice.invoiceNumber.toString() : '(draft)';
        this.attachmentData.entityType = 'Invoice';
        this.attachmentData.readOnly = !this.currentInvoice.readyTaskId;
        this.attachmentData.canUseCustomOrdering = true;
        this.attachmentData.isCustomOrderingEnabled = !!this.currentInvoice.allowAttachmentCustomOrdering;

        // Build bundler context for invoice-specific defaults
        const siteIds = [this.currentInvoice.siteId].filter((id): id is number => Number.isInteger(id) && id > 0);
        const parcelIds = [...new Set((this.currentInvoice.appeals || []).map((a) => a.parcelID))].filter(
            (id): id is number => Number.isInteger(id) && id > 0,
        );
        const alreadyAttachedIds = (this._currentAttachments || []).map((a) => a.attachmentID);
        this.attachmentData.bundlerContext = {
            bundlerSource: Core.AttachmentBundlerScopeEnum.Invoice,
            companyId: this.currentInvoice.companyId,
            topLevelCompanyId: this.currentInvoice.topLevelCompanyId,
            siteIds,
            parcelIds,
            year: this.currentInvoice.annualYear,
            defaultLocations: [
                Core.AttachmentBundlerLocationEnum.Site,
                Core.AttachmentBundlerLocationEnum.Parcel,
                Core.AttachmentBundlerLocationEnum.AssessmentRevision,
                Core.AttachmentBundlerLocationEnum.Appeal,
                Core.AttachmentBundlerLocationEnum.TaxBill,
            ],
            defaultCategories: [
                Core.AttachmentCategories.AppealDocs,
                Core.AttachmentCategories.AuthorizationsAndLetters,
                Core.AttachmentCategories.BillsAndPayments,
                Core.AttachmentCategories.EngagementDocs,
                Core.AttachmentCategories.ValueNotices,
            ],
            alreadyAttachedIds,
        } as AttachmentBundlerContext;

        // Determine company type: top-level when topLevelCompanyId is absent or equals companyId
        this.attachmentData.bundlerContext.isTopLevelCompany =
            !this.currentInvoice.topLevelCompanyId ||
            this.currentInvoice.topLevelCompanyId === this.currentInvoice.companyId;
    }

    setEditMode(): void {
        // Normally hitting "edit" means you can edit the invoice; however if it's completed, we still want an edit button
        // so the user can change tasks (WK-4287). Instead of trying to lock down parts of the interface in edit mode
        // when the invoice is complete, we'll use a single flag to indicate we're just allowing status edits
        if (!this.isInvoiceCompleted) {
            this.editMode = true;
            this.navigationService.enableNavWarning(this._navigationWarningText);

            //stash the current invoice in case of cancel
            const cacheInvoice = structuredClone(this.currentInvoice);
            this._resetOtherParcelCalc(cacheInvoice);
            this.cachedInvoice = cacheInvoice;
        } else {
            this.taskOnlyEditMode = true;
            this.navigationService.enableNavWarning(this._navigationWarningText);
        }
    }

    setButtonText(): void {
        switch (this.currentInvoice.readyTaskTypeId) {
            case TaskType.PrepareDraftInvoice:
                this.completeText = 'Complete Draft (Request Review)';
                break;
            case TaskType.ReviewDraftInvoice:
                this.completeText = `Complete Review (Request ${this.currentInvoice.isUBR ? 'UBR ' : ''}RIBS Transfer)`;
                break;
            case TaskType.TransferUBRToRIBS:
                this.completeText = 'Transfer UBR to RIBS (Request Relief of UBR)';
                break;
            case TaskType.RequestReliefOfUBR:
                this.completeText = 'Request Relief of UBR (Request RIBS Transfer)';
                break;
            case TaskType.TransferInvoiceToRIBS:
                this.completeText = 'Transfer to RIBS';
                break;
            case TaskType.AdjustInvoice:
                this.completeText = 'Complete Adjust Invoice';
                break;
        }

        if (this.taskList && this.taskList.length > 1 && this.taskIndex < this.taskList.length - 1) {
            this.completeText += ' and Show Next';
            this.closeText = 'Skip';
        } else {
            this.closeText = 'Close';
        }
    }

    cancelEdit(): void {
        if (this.taskOnlyEditMode) {
            this.taskOnlyEditMode = false;
        } else {
            this.loading = true;
            this._cdRef.detectChanges();

            //Warn users if there's data lost
            //Reset the currentInvoice from cache if necessary
            this.currentInvoice = this.cachedInvoice;

            // Reset the selected recipient
            this.invoiceRecipientLookup.setSelectedRecipient();

            //Clear cache version
            this.cachedInvoice = null;

            //Set edit mode false
            this.editMode = false;
            this.loading = false;

            this._calculateCurrentTermId();
        }

        this.navigationService.disableNavWarning();
    }

    async launchTaskModal(): Promise<void> {
        // if not in edit mode just open the tasks modal
        if (!this.editMode) {
            if (this.taskOnlyEditMode) {
                // In this case, the invoice is complete; if the user opens the task modal and rescinds a task, it's likely that the page
                // was originally loaded with the assumption that the invoice was complete, and that is now not true. Just reload the data
                // in that case so we can rebuild the page under the correct assumption about the invoice's complete status
                const shouldReload = await this.launchTaskModalService.launchTaskModal(
                    this.currentInvoice.invoiceId,
                    EntityType.Invoice,
                    false,
                    null,
                    false,
                );

                if (shouldReload) {
                    this.taskOnlyEditMode = false;
                    await this.setupPage();
                }
            } else {
                await this.launchTaskModalService.launchTaskModal(
                    this.currentInvoice.invoiceId,
                    EntityType.Invoice,
                    true,
                    null,
                    true,
                );
            }
            return;
        }

        // in edit mode, check to see if there have been any changes
        // if there have been changes save them otherwise keep current invoice

        if (this._hasChanges()) {
            try {
                await this.save();
            } catch (e) {
                this.showError(e);
                await this.messageBox.alert(
                    'Please undo your changes or click Save to see the specific error',
                    'Error saving changes to invoice before opening task modal.',
                    true,
                );
                return Promise.reject();
            }
        }

        // open tasks modal
        const hasChanges = await this.launchTaskModalService.launchTaskModal(
            this.currentInvoice.invoiceId,
            EntityType.Invoice,
            false,
            null,
            false,
        );
        // if any changes were made in the modal then reload the current invoice so we can get the updated status
        if (hasChanges) {
            await this.setupPage();
            // done reloading, if we're still in edit mode (no changes were previously saved) then exit edit mode
            if (this.editMode) {
                this.cancelEdit();
            }
        }
    }

    async save(): Promise<Invoice> {
        const validationMessage: string = this._getValidationMessage();

        if (validationMessage) {
            this._toastr.error(validationMessage);

            return;
        }

        this.loading = true;

        try {
            this._resetOtherParcelCalc(this.currentInvoice);
            const newInvoice = await this.invoiceService.saveInvoice(this.currentInvoice);

            const calcInvoice: Invoice = this.invoiceService.calculateInvoiceData(newInvoice);
            this.currentInvoice = calcInvoice;
            this.cachedInvoice = structuredClone(calcInvoice);
            this._processNewInvoice();

            this.editMode = false;
            this.navigationService.disableNavWarning();

            this.loading = false;
            this._toastr.success('Your invoice has successfully been saved', 'Success');

            this._calculateCurrentTermId();

            return this.currentInvoice;
        } finally {
            this.loading = false;
        }
    }

    _getValidationMessage(): string {
        if (
            (this.currentInvoice.previousFMV || this.currentInvoice.previousFMV === 0) &&
            (this.currentInvoice.invoiceFMV || this.currentInvoice.previousFMV === 0) &&
            this.currentInvoice.previousFMV < this.currentInvoice.invoiceFMV
        ) {
            return 'Previous FMV cannot be less than Invoice FMV!';
        }

        if (
            (this.currentInvoice.previousMV || this.currentInvoice.previousMV === 0) &&
            (this.currentInvoice.invoiceMV || this.currentInvoice.invoiceMV === 0) &&
            this.currentInvoice.previousMV < this.currentInvoice.invoiceMV
        ) {
            return 'Previous MV cannot be less than Invoice MV!';
        }

        const hasMultipleTaxableValues = this.currentInvoice.taxSavings.some((x) =>
            x.parcelSavingsCalculations.some(
                (y) => y.appealRevisionCalculations.length > 1 || y.outcomeRevisionCalculations.length > 1,
            ),
        );

        const invoice = structuredClone(this.currentInvoice);
        this._resetOtherParcelCalc(invoice);

        if (
            (!hasMultipleTaxableValues ||
                (hasMultipleTaxableValues &&
                    invoice.previousTAV !== Number(invoice.previousTAVOriginal) &&
                    invoice.invoiceTAV !== Number(invoice.invoiceTAVOriginal))) &&
            (this.currentInvoice.previousTAV || this.currentInvoice.previousTAV === 0) &&
            (this.currentInvoice.invoiceTAV || this.currentInvoice.invoiceTAV === 0) &&
            this.currentInvoice.previousTAV < this.currentInvoice.invoiceTAV
        ) {
            return 'Previous TAV cannot be less than Invoice TAV!';
        }

        if (
            (this.currentInvoice.previousFMV === 0 ||
                (this.currentInvoice.feeAmount && this.currentInvoice.contingencyCap)) &&
            this.currentInvoice.feeAmount > this.currentInvoice.contingencyCap
        ) {
            return 'Fee Amount cannot be greater than Contingency Cap!';
        }

        return '';
    }

    async delete(): Promise<void> {
        try {
            await this.messageBox.confirm('Are you sure you wish to delete this invoice?');
        } catch {
            this.loading = false;
            return;
        }

        this.navigationService.disableNavWarning();
        this.loading = true;

        try {
            await this.invoiceService.deleteInvoice(this.currentInvoice.invoiceId);
            this.navigateBackHandler();
        } catch (err) {
            this._toastr.error(err.error.message);
        } finally {
            this.loading = false;
        }
    }

    async complete(): Promise<void> {
        if (
            this.currentInvoice.readyTaskTypeId == TaskType.TransferInvoiceToRIBS &&
            !this.currentInvoice.thirdPartyApprovalDate
        ) {
            this._toastr.error('Third Party Approval Date required for transfer to RIBS');
            return;
        }

        if (
            !this.currentInvoice.recipientName &&
            this.currentInvoice.readyTaskTypeId !== TaskType.PrepareDraftInvoice
        ) {
            this._toastr.error('Please select recipient', 'Problem Completing Invoice');
            return;
        }

        this.loading = true;
        this.callInProgress = true;

        try {
            const toSend = structuredClone(this.currentInvoice);
            this._resetOtherParcelCalc(toSend);
            const returnedInvoice = await this.invoiceService.completeInvoice(toSend);

            this.currentInvoice = returnedInvoice;
            this.cachedInvoice = returnedInvoice;
            this._processNewInvoice();

            this._toastr.success('Invoice successfully completed', 'Success!');
            this.setButtonText();

            this.loading = false;
            this.callInProgress = false;

            const state = this.navigationServiceHandler.getCurrentState();
            if (state.name === InvoiceRouteNames.Processing) {
                if (this.taskIndex < this.taskList.length - 1) {
                    this.taskIndex++;
                    this.currentInvoice = null;
                    this.showCompleteButton = this.canTransferToRIBS;
                    this.invoiceDetailsCompletedDate = null;
                    this.cachedInvoice = null;
                    await this.getInvoiceForTask(this.taskList[this.taskIndex]);
                } else {
                    this.loading = true;
                    this.currentInvoice = null;
                    this.showCompleteButton = this.canTransferToRIBS;
                    this.invoiceDetailsCompletedDate = null;
                    this.cachedInvoice = null;

                    await this.messageBox.open({
                        title: 'SUCCESS',
                        message: 'You have successfully completed all invoices. Click ok to return',
                        buttons: MessageModalButtons.OK,
                        displayMode: MessageModalDisplayMode.SingleMessage,
                    });

                    this.navigationService.disableNavWarning();
                    this.navigateBackHandler();
                }
            } else {
                await this.messageBox.open({
                    title: 'SUCCESS',
                    message: 'You have successfully completed your invoice. Click ok to return',
                    buttons: MessageModalButtons.OK,
                    displayMode: MessageModalDisplayMode.SingleMessage,
                });

                this.navigationService.disableNavWarning();
                this.navigateBackHandler();
            }
        } catch (error) {
            this.showError(error);

            this.loading = false;
            this.callInProgress = false;

            return Promise.reject();
        }
    }

    showError(err: unknown): void {
        // Custom error type that extends Error and allows extra properties
        type SaveError = Error & {
            status?: number;
            data?: any;
            error?: { message?: string };
        };

        const error = err as SaveError;

        // If a 400 returns an array, they're validation errors
        if (error.status === 400 && Array.isArray(error.data)) {
            this._toastr.warning(error.data.join(', '), 'Problem completing invoice');
        } else {
            const errorMessage =
                error?.error?.message || error?.message || 'An error occurred while completing the invoice';
            this._toastr.error(errorMessage, 'Problem completing invoice');
        }
    }

    async skipInvoice(): Promise<void> {
        try {
            await this.messageBox.confirm(this._navigationWarningText);
        } catch {
            return;
        }

        if (this.taskIndex < this.taskList.length - 1) {
            this.taskIndex++;
            this.currentInvoice = null;
            this.showCompleteButton = this.canTransferToRIBS;
            this.invoiceDetailsCompletedDate = null;
            this.cachedInvoice = null;
            this._toastr.info('', 'Skipping Invoice...');
            this.callInProgress = true;
            await this.getInvoiceForTask(this.taskList[this.taskIndex]);
            this.callInProgress = false;
        } else {
            await this.messageBox.open({
                title: 'SUCCESS',
                message: 'You have completed or skipped all invoices. Click ok to return',
                buttons: MessageModalButtons.OK,
                displayMode: MessageModalDisplayMode.SingleMessage,
            });

            this.navigationService.disableNavWarning();
            this.navigateBackHandler();
        }
    }

    navigateBackHandler(): void {
        if (!this.currentState) {
            return;
        }

        if (this.currentState.name === InvoiceRouteNames.Site) {
            this.navigationServiceHandler.go('site', {
                companyId: this.currentInvoice.companyId,
                siteId: this.currentInvoice.siteId,
            });
        } else if (this.currentState.name === InvoiceRouteNames.Company) {
            if (this._featureFlagsService.featureFlags.enableDynamicCompanyPage) {
                this.navigationServiceHandler.go('companyInvoices', { companyId: this.currentInvoice.companyId });
            } else {
                this.navigationServiceHandler.go('company', { companyId: this.currentInvoice.companyId });
            }
        } else {
            const route = this.actionViewStateService.getReturnRoute(
                this.actionViewPersistenceService.routeParams ?? {},
            );
            this.navigationServiceHandler.go(route.state, route.params);
        }
    }

    onContractServiceTypeChange(): void {
        const term = this._siteAppealContractTerms.find(
            (x) =>
                x.serviceId === +this.currentInvoice.contractServiceType &&
                (x.taxYear === this.currentInvoice.annualYear || !x.taxYear),
        );
        this._updateInvoice(term.currentTermItem);
    }

    onContractTermChange(contractTermDetailId: number) {
        const contractTermDetail = this.companyAppealContractTerms.find(
            (x) => x.contractTermDetailId === +contractTermDetailId,
        );
        this._updateInvoice(contractTermDetail);

        this._isContractTermOverridden = !contractTermDetail.siteDefault;
    }

    onIsRyanLegalServicesChanged() {
        this.currentInvoice = { ...this.currentInvoice };
        this._processNewInvoice();
    }

    private _hasChanges(): boolean {
        return this.editMode && !_.isEqual(this.currentInvoice, this.cachedInvoice);
    }

    private _processNewInvoice() {
        this.showCompleteButton =
            this.currentInvoice.readyTaskTypeId !== TaskType.TransferInvoiceToRIBS || this.canTransferToRIBS;
        this.invoiceDetailsCompletedDate = this.currentInvoice.taskSummary.completedDateTime
            ? new Date(this.currentInvoice.taskSummary.completedDateTime)
            : null;

        this.breadcrumbs = [
            {
                name: this.currentInvoice.companyName,
                target: 'company',
                options: { companyId: this.currentInvoice.companyId },
            },
        ];

        if (!this._siteIdParam && this._featureFlagsService.featureFlags.enableDynamicCompanyPage) {
            this.breadcrumbs.push({
                name: 'Invoices',
                target: this._siteIdParam ? 'siteInvoices' : 'companyInvoices',
                options: {
                    companyId: this.currentInvoice.companyId,
                    siteId: this.currentInvoice.siteId,
                },
            });
        }

        if (this.currentInvoice.siteName) {
            this.breadcrumbs.push({
                name: this.currentInvoice.siteName,
                target: 'site',
                options: {
                    companyId: this.currentInvoice.companyId,
                    siteId: this.currentInvoice.siteId,
                },
            });
        }
    }

    private _updateInvoice(term: TermItem | ContractTerm) {
        this.loading = true;
        this._cdRef.detectChanges();

        this.currentInvoice.contingencyPctOriginal = term.contingencyPct;
        this.currentInvoice.contingencyPct = term.contingencyPct;
        this.currentInvoice.contingencyCapOriginal = term.contingencyCap;
        this.currentInvoice.contingencyCap = term.contingencyCap;
        this.currentInvoice.fixedFee = term.flatFee;
        this.currentInvoice.fixedFeeOriginal = term.flatFee;

        this._currentContractTerm = {
            contingencyPct: this.currentInvoice.contingencyPct,
            contingencyCap: this.currentInvoice.contingencyCap,
            flatFee: this.currentInvoice.fixedFee,
        } as ContractTerm;

        this.currentInvoice.feeAmountStatus = OverrideStatus.Recalculated;

        this._resetOtherParcelCalc(this.currentInvoice);
        const invoice = this.invoiceService.calculateInvoiceData(this.currentInvoice);
        this.currentInvoice = {
            ...invoice,
            feeAmountStatus: OverrideStatus.Default,
        };
        this._processNewInvoice();

        this.loading = false;
    }

    private stashCurrentInvoice(invoice: Invoice) {
        invoice.invoiceRevenueShareCodes = invoice.invoiceRevenueShareCodes.map((x) => {
            x.allocationPct = x.allocationPct || 0;
            return x;
        });

        this.cachedInvoice = structuredClone(invoice);
    }

    private _calculateCurrentTermId() {
        const selectedContractTermDetail = this.companyAppealContractTerms.find(
            (x) =>
                x.contractServiceTypeId === this.currentInvoice.contractServiceType &&
                ((x.propertyTypeId && x.propertyTypeId === this.currentInvoice.propertyTypeID) || !x.propertyTypeId) &&
                (x.taxYear === this.currentInvoice.annualYear || !x.taxYear) &&
                ((!x.contingencyPct && !this.currentInvoice.contingencyPctOriginal) ||
                    x.contingencyPct === this.currentInvoice.contingencyPctOriginal) &&
                ((!x.contingencyCap && !this.currentInvoice.contingencyCapOriginal) ||
                    x.contingencyCap === this.currentInvoice.contingencyCapOriginal) &&
                ((!x.flatFee && !this.currentInvoice.fixedFeeOriginal) ||
                    x.flatFee === this.currentInvoice.fixedFeeOriginal),
        );

        if (selectedContractTermDetail) {
            this.currentContractTermDetailId = selectedContractTermDetail.contractTermDetailId;

            this._currentContractTerm = {
                contingencyPct: this.currentInvoice.contingencyPct,
                contingencyCap: this.currentInvoice.contingencyCap,
                flatFee: this.currentInvoice.fixedFee,
            } as ContractTerm;
        }

        this._isContractTermOverridden = !selectedContractTermDetail || !selectedContractTermDetail.siteDefault;
    }

    private async _initFromCurrentInvoice() {
        this.isAppealSavingsInvoice =
            !this.currentInvoice.isAdHoc &&
            (this.currentInvoice.contractServiceType === ContractServiceType.Appeal ||
                this.currentInvoice.contractServiceType === ContractServiceType.Litigation ||
                this.currentInvoice.contractServiceType === ContractServiceType.LitigationAdmin ||
                this.currentInvoice.contractServiceType === ContractServiceType.LitigationOnly);

        if (this.isAppealSavingsInvoice) {
            this._siteAppealContractTerms = await this._contractsInvoicesService.getContractTermsBySite(
                this.currentInvoice.siteId,
            );

            const availableAppealContractTypeIds = [
                ...new Set(
                    this._siteAppealContractTerms
                        .filter((x) => !x.taxYear || x.taxYear === this.currentInvoice.annualYear)
                        .map((x) => x.serviceId),
                ),
            ];
            this.appealContractTypes = Object.keys(this.constants.ContractServiceTypes)
                .map((key) => {
                    return {
                        value: this.constants.ContractServiceTypes[key].id,
                        name: this.constants.ContractServiceTypes[key].name,
                    };
                })
                .filter(
                    (t) =>
                        [
                            ContractServiceType.Appeal,
                            ContractServiceType.Litigation,
                            ContractServiceType.LitigationOnly,
                        ].includes(t.value) && availableAppealContractTypeIds.includes(t.value),
                );

            const hasLitigationContractTypes = this._siteAppealContractTerms.some(
                (x) =>
                    (x.serviceId === ContractServiceType.Litigation ||
                        x.serviceId === ContractServiceType.LitigationOnly) &&
                    (!x.taxYear || x.taxYear === this.currentInvoice.annualYear),
            );
            const hasAppealContractTypes = this._siteAppealContractTerms.some(
                (x) =>
                    x.serviceId === ContractServiceType.Appeal &&
                    (!x.taxYear || x.taxYear === this.currentInvoice.annualYear),
            );
            this.canChangeContractType = hasLitigationContractTypes && hasAppealContractTypes;

            const companyContractTerms = await this._contractsInvoicesService.getContractTermsByCompany(
                this.currentInvoice.companyId,
            );
            const currentCompanyContractTerms =
                companyContractTerms.currentContractTerms?.length > 0
                    ? companyContractTerms.currentContractTerms
                    : companyContractTerms.topLevelCompanyContractTerms;
            this.companyAppealContractTerms = currentCompanyContractTerms.filter(
                (x) =>
                    x.contractServiceTypeId === this.currentInvoice.contractServiceType &&
                    (!x.taxYear || x.taxYear === this.currentInvoice.annualYear),
            );
            this._calculateCurrentTermId();
        } else {
            this.appealContractTypes = [];
            this._siteAppealContractTerms = [];
            this.canChangeContractType = false;
            this.companyAppealContractTerms = [];
            this.currentContractTermDetailId = null;
        }

        this._currentContractTerm = {
            contingencyPct: this.currentInvoice?.contingencyPct,
            contingencyCap: this.currentInvoice?.contingencyCap,
            flatFee: this.currentInvoice?.fixedFee,
        } as ContractTerm;
    }

    protected onCustomOrderingEnabledChange(isCustomOrderingEnabled: boolean): void {
        // Keep the cached invoice and modal data in sync with the persisted state so reopening
        // the Attachments modal (without a full page refresh) reflects the correct toggle value.
        this.currentInvoice.allowAttachmentCustomOrdering = isCustomOrderingEnabled;
        this.attachmentData.isCustomOrderingEnabled = isCustomOrderingEnabled;

        if (this.cachedInvoice) {
            this.cachedInvoice.allowAttachmentCustomOrdering = isCustomOrderingEnabled;
        }
    }

    protected onAttachmentEntityRowVersionChange(rowVersion: string): void {
        // Toggling "Allow Custom Ordering" from the Attachments modal persists directly to the
        // Invoice row (outside of this page's own Save flow), bumping its row version. Refresh our
        // cached row version so a subsequent Save doesn't submit a stale value and trigger a
        // spurious "modified by another user" concurrency error (#585561).
        if (!rowVersion) {
            return;
        }

        this.currentInvoice.invoiceRowVersion = rowVersion;

        if (this.cachedInvoice) {
            this.cachedInvoice.invoiceRowVersion = rowVersion;
        }
    }

    protected allAttachments(allAttachments: Attachment[]) {
        this._currentAttachments = allAttachments || [];
        const hasTaxSavingsWorksheets = allAttachments.some(
            (x) => x.attachmentTypeID === AttachmentTypes.TaxSavingsWorksheet,
        );
        this.currentInvoice.includeTaxSavingsWorksheet = hasTaxSavingsWorksheets;

        if (this.cachedInvoice) {
            this.cachedInvoice.includeTaxSavingsWorksheet = hasTaxSavingsWorksheets;
        }
    }

    private _resetOtherParcelCalc(invoice: Invoice) {
        // Undo other parcel calc to prevent saving incorrect values
        if (invoice.taxSavings?.length > 0 && invoice.includeOtherParcels) {
            invoice.previousMV = invoice.previousMV - invoice.otherParcelMV;
            invoice.previousTAV = invoice.previousTAV - invoice.otherParcelTaxableAV;
            invoice.invoiceMV = invoice.invoiceMV - invoice.otherParcelMV;
            invoice.invoiceTAV = invoice.invoiceTAV - invoice.otherParcelTaxableAV;
        }
    }
}
